import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Separator } from 'app/design/primitives/text-divider';
import { useTranslation } from 'react-i18next';
import { NeedToggleCard } from './need-toggle-card';
import type { NeedToggle } from './notification-toggle.types';
import { ResponsiveSectionTitle } from './responsive-section-title';

export const NeedNotificationSection = ({
  isLargeUI,
  toggles,
  usesSectorNeedSources,
}: {
  isLargeUI: boolean;
  toggles: NeedToggle[];
  usesSectorNeedSources: boolean;
}) => {
  const { t } = useTranslation('notifications-setting');
  return (
    <>
      <Separator onlyWidth />
      <ResponsiveSectionTitle {...{ isLargeUI }}>{t('needTitle')}</ResponsiveSectionTitle>
      <Text variant="bodyBase">{t('needHelp')}</Text>
      <Column gap="spacing.general.x4">
        {toggles.map((toggle) => (
          <NeedToggleCard key={toggle.label} {...{ toggle, usesSectorNeedSources }} />
        ))}
      </Column>
      <Separator onlyWidth />
    </>
  );
};
